import { combineReducers } from "redux";
import bestpriceproperty from "../features/admin/bestproperty/bestpriceproperty/Slice";




const bestproperty = combineReducers({
   bestpriceproperty: bestpriceproperty,
  
  });
  
  export default bestproperty;